var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 8.505C10.065 8.505 8.505 10.08 8.505 12C8.505 13.92 10.08 15.495 12 15.495C13.92 15.495 15.495 13.92 15.495 12C15.495 10.08 13.92 8.505 12 8.505ZM22.5 12C22.5 10.545 22.5 9.12 22.425 7.665C22.35 5.985 21.96 4.485 20.73 3.27C19.5 2.04 18.015 1.65 16.335 1.575C14.88 1.5 13.455 1.5 12 1.5C10.545 1.5 9.12 1.5 7.665 1.575C5.985 1.65 4.485 2.04 3.27 3.27C2.04 4.5 1.65 5.985 1.575 7.665C1.5 9.12 1.5 10.545 1.5 12C1.5 13.455 1.5 14.88 1.575 16.335C1.65 18.015 2.04 19.515 3.27 20.73C4.5 21.96 5.985 22.35 7.665 22.425C9.12 22.5 10.545 22.5 12 22.5C13.455 22.5 14.88 22.5 16.335 22.425C18.015 22.35 19.515 21.96 20.73 20.73C21.96 19.5 22.35 18.015 22.425 16.335C22.515 14.895 22.5 13.455 22.5 12ZM12 17.385C9.015 17.385 6.615 14.985 6.615 12C6.615 9.015 9.015 6.615 12 6.615C14.985 6.615 17.385 9.015 17.385 12C17.385 14.985 14.985 17.385 12 17.385ZM17.61 7.65C16.92 7.65 16.35 7.095 16.35 6.39C16.35 5.685 16.905 5.13 17.61 5.13C18.315 5.13 18.87 5.685 18.87 6.39C18.8738 6.5543 18.8438 6.71764 18.7819 6.86987C18.7199 7.02211 18.6274 7.16 18.51 7.275C18.395 7.39241 18.2571 7.48495 18.1049 7.54687C17.9526 7.6088 17.7893 7.6388 17.625 7.635L17.61 7.65Z",
    fill: "#FFF6ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.c6ad2f722f16bf391750d004fa234660.svg";
export { ForwardRef as ReactComponent };